import React from 'react';
import pluralize from 'pluralize';
import { InfoCardWithVerticalBarChartWidget } from '../../../../statisticsWidgets/statisticsWidgets';

export default ({ data, loading, title, chartData, comment }) => {
  const commentText = comment || (chartData && chartData.length > 0 ?
    'Move mouse over the bar to see average progress per Group member.' :
    'Church members haven\'t got any Event seeds.');
  const barTooltip = (datum) => `${datum.x}\n${pluralize('seed', datum.y, true)}`;

  return <InfoCardWithVerticalBarChartWidget primaryColor="#5ecf78" secondaryColor="#595959" icon="icon-group"
                                             comment={commentText} barTooltip={barTooltip}
                                             title={title} data={data} chartData={chartData} loading={loading} />;
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/widgets/groupComparison.js